exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#nongkrong-bareng-barry-thankyou-page{background-image:url(https://ik.imagekit.io/zlt25mb52fx/ahmcdn/uploads/page/banner/background-nongkrong-bareng-barry-13062025-020636.webp);background-size:cover;background-position:50%;min-height:100dvh}", ""]);

// exports
